<ng-container *ngIf="authService.isAuthenticated(); else noauth">
  <ng-container *ngIf="favorite$ | async; else add">
    <ng-content select=".remove">
    </ng-content>
  </ng-container>
  <ng-template #add>
    <ng-content select=".add">
    </ng-content>
  </ng-template>
</ng-container>
<ng-template #noauth>
  <span (click) = "goToLogin()">
    <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
  </span>
</ng-template>
<ng-template #tempOutlet>
  <ng-content select=".noauth"></ng-content>
</ng-template>
